import { Component } from "react";

/** Fångar oväntade JS-fel så att appen visar ett tydligt meddelande i stället för trasig sida. */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Oväntat fel i gränssnittet:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex min-h-[60vh] items-center justify-center px-4" data-testid="error-boundary">
        <div className="w-full max-w-md rounded-lg border border-red-200 bg-red-50 p-6 text-center">
          <h1 className="text-xl font-semibold text-slate-900">Något gick fel i vyn</h1>
          <p className="mt-2 text-sm text-slate-700">
            Ingen data har påverkats. Ladda om sidan – kvarstår felet, kontakta oss.
          </p>
          <button
            type="button"
            data-testid="error-boundary-reload"
            onClick={() => window.location.reload()}
            className="mt-4 h-11 w-full rounded-md bg-blue-600 px-4 text-sm font-semibold text-white transition-colors duration-200 hover:bg-blue-700"
          >
            Ladda om sidan
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
